import { FaExclamationCircle } from "react-icons/fa";
import { formatarDinheiro } from "_utils/Money";
import { Alerta, Header, LinhaItem, Placa, Tabela, Titulo } from "./style";

export interface IDebitoAdicional {
  tipo: string;
  valor: number;
}

interface IProps {
  placa: string;
  debitos: IDebitoAdicional[];
  pago?: boolean;
}

export function PopoverDebitosAdicionais({
  placa,
  debitos,
  pago = false,
}: IProps) {
  return (
    <>
      <Titulo>Débitos adicionais</Titulo>
      <Alerta>
        <FaExclamationCircle size={14} />
        <span>
          Além da taxa de transferência, {pago ? "foram pagos" : "foram encontrados"}{" "}
          outros débitos vinculados ao veículo selecionado.
        </span>
      </Alerta>
      <Placa>{placa}</Placa>
      <Tabela>
        <Header>
          <span>Débito</span>
          <span>Valor</span>
        </Header>
        {debitos.map((debito, indice) => (
          <LinhaItem key={`${debito.tipo}-${indice}`}>
            <span>{debito.tipo}</span>
            <span>{formatarDinheiro(debito.valor)}</span>
          </LinhaItem>
        ))}
      </Tabela>
    </>
  );
}
